export default {
  driver_performance_events_assingStatus_status: "Estado",
  driver_performance_events_assingStatus_selectStatus: "Seleccionar Estado",
  driver_performance_events_assingStatus_title: "Establecer Estado",
  driver_performance_events_assingStatus_success: "Estado actualizado con éxito",
  driver_performance_events_assingStatus_error: "Error al actualizar el estado",
  driver_performance_changes_saved_successfully: "Cambios guardados con éxito",
  driver_performance_comment_saved_successfully: "Comentario guardado con éxito",
  driver_performance_error_saving: "Error al guardar los cambios",
  driver_performance_comments: "Comentarios",
  driver_performance_no_comments: "Aún no hay comentarios",
  driver_performance_add_comment: "Agregar un comentario",
};